import { isNetSuiteUrlValid } from '../validations/validations';

export const getVendorWebAddressTransfer = (webAddress: string | null | undefined) =>
    webAddress ? webAddress.replace(/^(?!https:\/\/)/, 'https://') : null;

export const isVendorWebAddressValid = (webAddress: string | null | undefined) => {
    const webAddressTransfer = getVendorWebAddressTransfer(webAddress);

    return !webAddressTransfer || isNetSuiteUrlValid(webAddressTransfer);
};
